import { OnsipAPIBoolean, onsipApiBooleanToBoolean } from "../../apiResponse/xml-json";

export interface ApiMohAddressBrowse {
  Address: ApiMohAddress;
  Enhanced: OnsipAPIBoolean;
  MaxChannels: string;
}

export interface ApiMohAddress {
  AddressId: string;
  CplText: string;
  Created: string;
  Domain: string;
  Modified: string;
  Name: string;
  Type: string;
  Username: string;
}

export interface MohAddress {
  addressId: string;
  created: string;
  domain: string;
  modified: string;
  name: string;
  type: string;
  username: string;
  cplText: string;
  enhanced: boolean;
  maxChannels: number;
}

export interface MohAddressEdit {
  Address: string;
  Enhanced: string;
  MaxChannels: string;
}

export function convertApiResponse(data: ApiMohAddressBrowse): MohAddress {
  return {
    addressId: data.Address.AddressId,
    created: data.Address.Created,
    domain: data.Address.Domain,
    modified: data.Address.Modified,
    name: data.Address.Name,
    type: data.Address.Type,
    username: data.Address.Username,
    maxChannels: parseInt(data.MaxChannels),
    enhanced: onsipApiBooleanToBoolean(data.Enhanced),
    cplText: data.Address.CplText
  };
}
